export enum VideoSubmissionStatus {
  PENDING = 'pending',
  IN_REVIEW = 'in_review',
  REVIEWED = 'reviewed',
}

export type VideoSubmissionDto = {
  id: string;
  title: string;
  description?: string;
  sport?: string;
  videoUrl: string;
  thumbnailUrl?: string;
  fileSizeBytes?: number;
  status: VideoSubmissionStatus;
  organizationId: string;
  uploadedBy: {
    id: string;
    firstName?: string;
    lastName?: string;
  };
  assignedTo?: {
    id: string;
    email: string;
  };
  comments?: import('./video-comment.dto').VideoCommentDto[];
  reviewedAt?: string;
  createdAt: string;
  updatedAt: string;
};

export class CreateVideoSubmissionInputDto {
  title: string;

  description?: string;

  sport?: string;

  videoUrl?: string;

  thumbnailUrl?: string;

  fileSizeBytes?: number;
}

export class UpdateVideoSubmissionInputDto {
  title?: string;

  description?: string;

  sport?: string;

  status?: VideoSubmissionStatus;

  assignedToMemberId?: string;

  thumbnailUrl?: string;
}
